/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_ITEM(state, item) {
    state.items.unshift(item)
  },
  SET_ITEM(state, item) {
    state.item = item
  },
  REMOVE_ITEM(state, itemId) {
    const userIndex = state.items.findIndex((u) => u.id == itemId)
    state.items.splice(userIndex, 1)
  },
  UPDATE_ITEM(state, item) {
    const itemIndex = state.items.findIndex((t) => t.id == item.id)
    Object.assign(state.items[itemIndex], item)
  }
}
